import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ServicesCard from "./ServiceCards";
import Particle from "../Particle";
import nominas from "../../Assets/Software/nominas.png";
import bancos from "../../Assets/Software/bancos.png";
import comercial from "../../Assets/Software/comercial.png";
import crm from "../../Assets/Software/crm.png";
import factura_electronica from "../../Assets/Software/factura_electronica.png";
import cfdi_linea from "../../Assets/Software/cfdi_linea.png";
import business_inteligence from "../../Assets/Software/business_inteligence.png";
import binder from "../../Assets/Software/binder.webp";
import xml_linea from "../../Assets/Software/xml_linea.png";
import cfdi_nominas from "../../Assets/Software/cfdi_nominas.jpg";
import contablilidad from "../../Assets/Software/contabilidad.png";
import Tilt from "react-parallax-tilt";
import { VscDebugBreakpointConditional } from "react-icons/vsc";
import { VscDebugBreakpointData } from "react-icons/vsc";


function Services() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
            Nuestros<strong className="purple"> Servicios</strong>
        </h1>
        <Row>
            <div className="service-list">
                <ul>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Instalación</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Actualización</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Capacitación</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Soporte Técnico</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Cursos</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Talleres</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Seminarios Informativos</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Venta de Sistemas</li>
                </ul>
                
            </div>
        </Row>
        <h1 className="project-heading">
            <strong className="purple"> Sistemas</strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ServicesCard
              imgPath={nominas}
              isBlog={false}
              title="CONTPAQi® Nóminas"
              description="Es el sistema de administración de la nómina que se adapta de manera fácil a tus procesos de cálculo, te ayuda a cumplir con todas las oblicaciones de ley y hacer un pago a tiempo a tus empleados."
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCard
              imgPath={bancos}
              isBlog={false}
              title="CONTPAQi® Bancos"
              description="Es el sistema con el que tu dinero siempre está a la vista, por que te ayuda a controlar tus ingresos y egresos, administrar tus cuentas bancarias y flujo de efectivo integrando la información de tus comprobantes fiscales digitales."
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCard
              imgPath={comercial}
              isBlog={false}
              title="CONTPAQi® Comercial"
              description="Es el sistema que mejor se adapta a tu administración comercia, integra los procesos de ventas, facturación, compras, inventarios, cuentas por cobrar y cuentas por pagar."
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCard
              imgPath={crm}
              isBlog={false}
              title="CONTPAQi® CRM"
              description="Es una aplicación que facilita la comunicación y seguimiento oportuno con tus clientes, haciendo a tus vendedores más productivos y veloces."
            />
          </Col>

          <Col md={4} className="project-card">
            <ServicesCard
              imgPath={factura_electronica}
              isBlog={false}
              title="Factura Electrónica"
              description="Es el sistema que facilita la emisión, timbrado y recepción de comprobantes fiscales digitales y el control de las cuentas por cobrar, para que puedas agilizar tus transacciones comerciales y ser más competitivo."
            />
          </Col>

        </Row>
        <h1 className="project-heading">
            <strong className="purple"> APPS Web</strong> (nube)
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
              <ServicesCard
                imgPath={cfdi_linea}
                isBlog={false}
                title="CFDI Facturación en linea +"
                description="Puedes facturar electrónicamente desde tu computadora, teléfono celular o tablet en el momento que necesites."
              />
          </Col>
          <Col md={4} className="project-card">
            <ServicesCard
              imgPath={business_inteligence}
              isBlog={false}
              title="CONTPAQi® Business Intelligence"
              description="Facilita la toma de decisiones oportunas a dueños o responsables de una pequeña o mediana empresa incluso estando fuera de la oficina. Se integra a CONTPAQi Comercial."
            />
          </Col>
          <Col md={4} className="project-card">
            <ServicesCard
              imgPath={binder}
              isBlog={false}
              title="CONTPAQi® Binder"
              description="Es una aplicación en la nube que facilita el envió y procesamiento de tu información contable. Te brinda claridad de los resultados de tu empresa y es el enlace perfecto con tu Contador."
            />
          </Col>
        </Row>
        <h1 className="project-heading">
            <strong className="purple"> APPS Desktop</strong> (escritorio)
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ServicesCard
              imgPath={xml_linea}
              isBlog={false}
              title="XML en Linea +"
              description="Facilita la búsqueda y descarga masiva de tus archivos XML sin necesidad de ingresar al portal del SAT."
            />
          </Col>
          <Col md={4} className="project-card">
            <ServicesCard
              imgPath={cfdi_nominas}
              isBlog={false}
              title="CFDI Nóminas +"
              description="Si solo deseas registrar y emitir recibos CFDI hasta 15 empleados, nuestra aplicación en Excel® facilitará tu trabajo."
            />
          </Col>
        </Row>
        <h1 className="project-heading">
            <strong className="purple"> Soporte</strong>
        </h1>
        <Row>
            <div className="service-list">
                <ul>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Instalación del Sistema</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Reinstalaciones</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Capacitación del Sistema Para el Personal</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Daños en el Sistema</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Base de Datos Dañadas</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Problemas Causados por Apagón</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Asistencia Online</li>
                    <li className="about-activity"> <VscDebugBreakpointConditional /> Asistencia Telefonica</li>
                </ul>
                
            </div>
        </Row>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "1.9em" }}>
              CONTPAQi®<span className="purple"> contabilidad </span>
            </h1>
            <div>
              <p className="home-about-body">
                Es el sistema contable integrador favorito de los Contadores que facilita el proceso de la información contable, financiera y fiscal
                de tu empresa, así como la recepción de tus comprobantes fiscales digitales. &nbsp;
                <br />
                Diseñado para contadores, fiscalistas, auditores, administradores y directores de todo perfil de empresas.
                <br />
                <br />
              </p>
              <ul>
                    <li className="about-activity"> <VscDebugBreakpointData  /> Cumples con la disposición de Contabilidad Electrónica.</li>
                    <li className="about-activity"> <VscDebugBreakpointData  /> Cumples con las Normas de Información Financiera (NIF)</li>
                    <li className="about-activity"> <VscDebugBreakpointData  /> Agilizas la contabilización de tus comprobantes de gastos.</li>
                    <li className="about-activity"> <VscDebugBreakpointData  /> Se Adapta fácilmente al manejo de tu contabilidad</li>
                    <li className="about-activity"> <VscDebugBreakpointData  /> Es eficiente en el cálculo y control del IVA, DyP y DIOT.</li>
                    <li className="about-activity"> <VscDebugBreakpointData  /> Incrementa tu velocidad de búsqueda.</li>
                    <li className="about-activity"> <VscDebugBreakpointData  /> Te brinda facilidad de captura.</li>
                    <li className="about-activity"> <VscDebugBreakpointData  /> Es versátil en la generación de reportes.</li>
                    <li className="about-activity"> <VscDebugBreakpointData  /> Agiliza la consulta de información contable y financiera.</li>
                    <li className="about-activity"> <VscDebugBreakpointData  /> Ahorras tiempo al integrarlo con otros procesos.</li>
                </ul>
            
            </div>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={contablilidad} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Services;
